export interface DomainToken {
  domain: string;
  accessToken: string;
}
